export const shopRoutes = [
  {
    path: '/shop',
    component: () => import('@/view/shop/tabber/tabber'),
    redirect:"/index",
    children: [
        {
            path: "/index",
            component: () => import('@/view/shop/main/index'),
            name: "shopIndex"
        },
        {
            path: "/category",
            component: () => import('@/view/shop/main/category/category'),
            name: "category"
        },
        {
            path: "/cart",
            component: () => import('@/view/shop/main/cart/cart'),
            name: "cart"
        },
        {
            path: "/profile",
            component: () => import('@/view/shop/main/profile/profile'),
            name: "profile"
        }
    ]
  },
  {
    path: '/orderlist',
    name: 'orderlist',
    component: () => import('@/view/shop/profile/order/orderlist'),
  },
  {
    path: '/address_list',
    name: 'addressList',
    component: () => import('@/view/shop/profile/address/address_list'),
  },
  {
    path: '/address_edit',
    name: 'addressEdit',
    component: () => import('@/view/shop/profile/address/address_edit'),
  }
]




// WEBPACK FOOTER //
// ./src/router/shop.js